// eslint-disable-next-line no-extend-native
Number.prototype.pad = function (n, width, z = '0') {
  const strN = `${n}`;
  return strN.length >= width
    ? n
    : new Array(width - n.length + 1).join(z) + n;
};
